export default {
  nav: {
    apartments: "Appartements",
    manifesto: "Manifeste",
    map: "Carte",
    contact: "Contact",
    book: "Réserver",
    menu: "Menu",
  },
  lang: { es: "Español", en: "English", fr: "Français", de: "Deutsch" },
  hero: {
    kicker: "Location temporaire en plein Cadix",
    line1: "Luz de Cádiz",
    line2: "appartements",
    sub: "Quatre appartements parfaits pour des groupes jusqu'à 8 personnes, à Playa Victoria ou dans la vieille ville. Réservation directe, sans commission.",
    cta1: "Voir les appartements",
    badge: "Télétravail et séjours de plus d'1 mois : conditions spéciales",
    scroll: "Défiler",
  },
  manifesto: {
    kicker: "Manifeste",
    chapters: [
      { n: "01", title: "La lumière", text: "Cadix possède une lumière qui n'existe nulle part ailleurs : latérale, blanche, elle rend tout plus net. Nos maisons sont pensées pour la laisser entrer." },
      { n: "02", title: "Le sel", text: "L'Atlantique se respire dans chaque rue. La Caleta, la Cortadura, le front de mer : l'océan n'est jamais à plus de dix minutes de votre porte." },
      { n: "03", title: "La chaux", text: "Patios chaulés, azulejos peints à la main, pierre d'huître. Quatre maisons pleines de lumière, chacune avec son quartier et son caractère." },
    ],
  },
  gallery: {
    kicker: "La collection",
    title: "Quatre maisons, un même océan",
    sub: "De la vieille ville à la Cortadura : choisissez votre Cadix.",
    guests: "voyageurs",
    bedrooms: "ch.",
    from: "dès",
    night: "nuit",
    view: "Voir l'appartement",
  },
  marquee: { items: ["Sel marin", "Couchers de soleil", "Atlantique turquoise", "Pescaíto frito", "Pierre d'huître"] },
  map: {
    kicker: "La carte",
    title: "Où dormir à Cadix",
    sub: "Quatre adresses choisies avec soin, de la vieille ville à la plage.",
    view: "Voir l'appartement",
  },
  contact: {
    kicker: "Contact",
    title: "Parlons-en",
    sub: "Dites-nous ce que vous cherchez et nous répondons en moins de 24 heures. Vous pouvez aussi nous écrire directement sur WhatsApp.",
    name: "Nom",
    email: "Email",
    phone: "Téléphone (optionnel)",
    message: "Message",
    send: "Envoyer le message",
    whatsapp: "Envoyer par WhatsApp",
    success: "Message envoyé. Nous répondons en moins de 24 h.",
    error: "Envoi impossible. Réessayez ou écrivez-nous sur WhatsApp.",
    response: "Réponse en moins de 24 h",
  },
  footer: {
    tagline: "Quatre appartements en plein Cadix : Playa Victoria et vieille ville.",
    rights: "Tous droits réservés.",
    seo: "Location temporaire à Cadix · Appartements temporaires en plein Cadix · Locations temporaires à Playa Victoria et vieille ville · Télétravail et travail à distance au bord de la mer · Séjours de plus d'un mois avec offres spéciales",
  },
  detail: {
    from: "dès",
    perNight: "/ nuit",
    guests: "voyageurs",
    bedrooms: "chambres",
    baths: "salles de bain",
    area: "m²",
    house: "La maison",
    amenities: "Équipements",
    district: "Le quartier",
    where: "Où ça se trouve",
    openMaps: "Ouvrir dans Google Maps",
    back: "Retour à la collection",
    notFound: "Appartement introuvable",
    longstayBadge: "Télétravailleurs · Séjours de plus d'1 mois · Offres spéciales — consultez prix et conditions",
    mapBlocked: "Vous avez refusé les cookies tiers : la carte Google ne se charge pas ici. Vous pouvez ouvrir l'adresse directement dans Google Maps :",
  },
  booking: {
    title: "Réservez votre séjour",
    checkin: "Arrivée",
    checkout: "Départ",
    nights: "nuits",
    night: "nuit",
    total: "Total",
    taxes: "Taxes calculées au paiement",
    cta: "Réserver et payer",
    whatsapp: "Demander sur WhatsApp",
    name: "Nom complet",
    email: "Email",
    phone: "Téléphone",
    errDates: "Choisissez vos dates d'arrivée et de départ",
    errFields: "Complétez votre nom, email et téléphone",
    errConflict: "Ces dates viennent d'être prises. Choisissez-en d'autres.",
    errGeneric: "Le paiement n'a pas pu démarrer. Réessayez.",
    secure: "Paiement sécurisé avec Stripe · Confirmation immédiate",
    legendFree: "Disponible",
    legendBusy: "Occupé",
    loading: "Redirection vers le paiement…",
    dogs: "Chiens",
    cribs: "Bébé (lit bébé)",
    cleaning: "Ménage final",
    linen: "Draps et serviettes",
    petsFee: "Animaux",
    discountLine: "Remise longue durée (−{{pct}}%)",
    consult: "Pour les séjours de plus d'un mois, nous avons des offres spéciales : contactez-nous sur WhatsApp",
    rateTitle: "Choisissez votre tarif",
    rateFlex: "Tarif flexible",
    rateStd: "Tarif standard",
    rateFlexPolicy: "24 h gratuites · Jusqu'à 15 jours avant l'arrivée : remboursement de 90% (moins l'acompte) · De 14 à 7 jours avant : 50% · À partir de 6 jours avant : aucun remboursement",
    rateStdPolicy: "15% de réduction sur l'hébergement · Non remboursable après les premières 24 h",
    depositNote: "Acompte de réservation : {{amount}} non remboursable, quel que soit le tarif, passées les 24 h suivant la réservation.",
    datesTitle: "Modifier les dates",
    nonrefLine: "Tarif non remboursable (−15% hébergement)",
    linenOptional: "en option",
    extrasNote: "Lits bébé et chaises hautes gratuits sur demande · Paniers et gamelles pour chiens gratuits sur demande",
    helpEmailSubject: "Demande de remboursement · {{apartment}}",
    errSummer: "En juillet et août, le séjour minimum est de 4 nuits (vous en avez {{nights}})",
    errWeekend: "Les nuits du vendredi et du samedi doivent être réservées ensemble",
    altTitle: "Cet appartement n'est pas libre à ces dates. Ceux-ci sont disponibles :",
    altDatesTitle: "Même appartement, dates alternatives (mêmes nuits) :",
    altNone: "Aucun autre appartement n'est libre à ces dates : écrivez-nous sur WhatsApp.",
    openNote: "Pour l'instant, les réservations en ligne sont pour juillet et août. Pour d'autres dates, écrivez-nous sur WhatsApp.",
    closed: "Les dates demandées sont complètes. Veuillez nous contacter à {{email}} pour plus d'informations.",
    errOpenMonths: "Pour l'instant, seules les dates de juillet et août peuvent être réservées en ligne",
    payTitle: "Moyen de paiement",
    pay_card: "Carte · Apple/Google Pay",
    pay_paypal: "PayPal",
    pay_bizum: "Bizum",
    feeService: "Frais de gestion du paiement (1%)",
    codePlaceholder: "Vous avez un code de réduction ?",
    codeApply: "Appliquer",
    codeOk: "Code appliqué : −{{pct}}%",
    codeInvalid: "Code non valide",
    codeApplied: "Code {{code}} (−{{pct}}%) appliqué",
    codeRemove: "Retirer",
    codeLine: "Code {{code}} (−{{pct}}%)",
  },
  success: {
    checking: "Confirmation de votre réservation…",
    title: "Réservation confirmée",
    sub: "Nous vous avons envoyé un email avec les détails. À bientôt à Cadix.",
    entry: "Arrivée",
    exit: "Départ",
    nights: "Nuits",
    total: "Total",
    whatsapp: "Nous prévenir sur WhatsApp",
    home: "Retour à l'accueil",
    pending: "Vérification du paiement",
    pendingSub: "Nous confirmons votre paiement avec la banque. Mise à jour dans quelques secondes.",
    sepaPending: "Nous avons enregistré votre prélèvement SEPA. La banque traitera le prélèvement sous 1 à 3 jours ouvrés et votre réservation sera confirmée automatiquement par email.",
    rate: "Tarif",
    rateFlex: "Flexible",
    rateNonref: "Non remboursable (−15%)",
    helpTitle: "Besoin d'annuler ou d'un remboursement ?",
    helpWa: "Écrire sur WhatsApp",
    helpEmail: "Envoyer un email",
  },
  search: {
    results: "Disponibilités",
    cta: "Rechercher",
    stay: "{{nights}} nuits · {{guests}} voyageurs",
    totalStay: "Total du séjour",
    book: "Voir et réserver",
    modify: "Modifier la recherche",
    available: "Disponible",
    noneTitle: "Aucune disponibilité complète",
    noneSub: "Aucun appartement n'est libre pour ces dates et ce nombre de voyageurs. Essayez d'autres dates ou écrivez-nous sur WhatsApp.",
    noDates: "Occupé à ces dates",
    altDates: "Dates alternatives pour cet appartement",
    noCapacity: "Capacité maximale : {{max}} voyageurs",
    unavailableTitle: "Indisponibles pour votre recherche",
    resultsFor: "Disponibles du {{from}} au {{to}}",
  },
  cancel: {
    title: "Réservation annulée",
    sub: "Aucun débit n'a été effectué. Vous pouvez réessayer quand vous voulez.",
    back: "Retour à la collection",
  },
  amenities: {
    wifi: "Wi-Fi fibre",
    ac: "Climatisation",
    kitchen: "Cuisine équipée",
    washer: "Lave-linge",
    tv: "TV",
    nespresso: "Nespresso",
    linen: "Draps et serviettes en option",
    babykit: "Lits bébé et chaises hautes gratuits sur demande",
    petkit: "Paniers et gamelles pour chiens gratuits sur demande",
    beachview: "Vue dégagée sur la plage",
    seaview: "Vue partielle sur la mer",
    balcony: "Balcon exposé ouest",
    dryer: "Sèche-cheveux",
    iron: "Fer à repasser",
    patio: "Patio andalou privé",
    bbq: "Barbecue portable",
    terrace: "Terrasse privée",
    parking: "Parking à proximité",
    bikes: "Vélos inclus",
    guide: "Guide local exclusif",
    light: "Mezzanine lumineuse",
    lift: "Ascenseur",
  },
  whatsapp: {
    floatLabel: "Écrivez-nous sur WhatsApp",
    generic: "Bonjour, l'un de vos appartements à Cadix m'intéresse.",
    booking: "Bonjour, je souhaite vérifier la disponibilité de {{apartment}} ({{checkin}} → {{checkout}}).",
    successMsg: "Bonjour, je viens de réserver {{apartment}} du {{checkin}} au {{checkout}}. Merci !",
    refund: "Bonjour, je souhaite demander l'annulation/le remboursement de ma réservation à {{apartment}} ({{checkin}} → {{checkout}}).",
  },
  remote: {
    kicker: "Télétravail à Cadix",
    title: "Télétravaillez face à l'Atlantique",
    text: "Wi-Fi fibre, appartements spacieux et lumineux et remises jusqu'à −55% sur les longs séjours. Plus d'un mois ? Écrivez-nous : nous avons des offres spéciales pour les télétravailleurs.",
    cta: "Voir les conditions",
    waMsg: "Bonjour, je télétravaille et je m'intéresse à un long séjour (plus d'un mois) dans l'un de vos appartements à Cadix. Quelles offres spéciales proposez-vous ?",
  },
  longstay: {
    kicker: "Télétravail et longs séjours",
    title: "Télétravaillez face à l'Atlantique",
    sub: "Quatre appartements spacieux et lumineux — en bord de plage ou dans la vieille ville — avec Wi-Fi fibre et tout le nécessaire pour vivre une saison à Cadix.",
    f1t: "Wi-Fi fibre",
    f1d: "Connexion rapide et stable pour les visioconférences et le travail quotidien.",
    f2t: "Espaces lumineux",
    f2d: "Grands appartements extérieurs, très lumineux, avec des coins confortables pour travailler.",
    f3t: "Remises automatiques",
    f3d: "−30% dès 7 nuits, −40% dès 8 et −55% dès 16, appliquées directement à la réservation.",
    f4t: "Plus d'un mois",
    f4d: "Écrivez-nous sur WhatsApp ou via le formulaire et nous vous ferons une offre spéciale télétravailleurs.",
    note: "Location temporaire à Cadix · Télétravail au bord de la mer · Offres spéciales longue durée",
  },
  instr: {
    kicker: "Presque terminé",
    title: "Finalisez votre paiement",
    loading: "Chargement…",
    error: "Nous ne trouvons pas cette réservation. Écrivez-nous sur WhatsApp.",
    amount: "Montant à payer",
    ref: "Référence",
    aptLabel: "Appartement",
    datesLabel: "Dates",
    bizumText: "Envoyez le montant par Bizum au {{phone}} en indiquant la référence de la réservation.",
    transferText: "Nous venons de vous envoyer un email avec les coordonnées bancaires pour le virement. Effectuez-le en indiquant la référence de la réservation.",
    paypalText: "Envoyez le montant via PayPal à {{email}} en indiquant la référence de la réservation.",
    warning: "Important : votre réservation reste EN ATTENTE jusqu'à réception du paiement. Les dates ne sont pas bloquées de manière définitive avant.",
    received: "Dès réception, nous vous envoyons la confirmation par email.",
    whatsapp: "Prévenir sur WhatsApp",
    waMsg: "Bonjour, je viens d'effectuer le paiement de ma réservation {{ref}} ({{apartment}}).",
  },
  paypal: {
    title: "Payer avec PayPal",
    notCompleted: "Le paiement n'a pas été finalisé",
    error: "Le paiement PayPal n'a pas pu être traité",
    notConfigured: "PayPal est en cours d'activation. En attendant, écrivez-nous sur WhatsApp et nous vous donnerons un autre moyen de paiement.",
  },
  cookies: {
    text: "Nous utilisons des cookies techniques propres et de tiers (paiements Stripe/PayPal et cartes Google) pour que le site fonctionne correctement. Nous ne suivons ni ne vendons vos données.",
    accept: "Accepter",
    reject: "Refuser",
    more: "Plus d'informations",
  },
  rules: {
    title: "Règles de la maison",
    r1: "Arrivée : 15 h · Départ : 12 h",
    r2: "Pas de bruit à partir de 22 h",
    r3: "Interdiction de fumer dans l'appartement, le hall ou les patios",
    r4: "Caution de 300 € par semaine : encaissée avec le même moyen de paiement à l'arrivée, après un état des lieux fait ensemble, et rendue au départ après une nouvelle vérification. Si quelque chose n'était pas conforme au document d'état remis, signalez-le dans les 12 h suivant l'arrivée.",
    r5: "Dans la mesure du possible, nous tenons compte des besoins de chaque hôte.",
  },
  legal: {
    notice: "Mentions légales",
    privacy: "Confidentialité",
    cookies: "Cookies",
    cancel: "Politique d'annulation",
    terms: "Conditions du séjour",
  },
  checkin: {
    kicker: "Enregistrement en ligne",
    notFound: "Nous ne trouvons pas cette réservation",
    backHome: "Retour au site",
    doneTitle: "Enregistrement terminé",
    doneText: "Voyageurs enregistrés, état des lieux signé et caution bloquée. Nous vous attendons le {{date}} à partir de 15h00.",
    summary: "{{checkin}} → {{checkout}} · {{nights}} nuits · {{guests}} voyageurs",
    step1: "1 · Informations de tous les occupants",
    step1Note: "Exigées par le registre des voyageurs (réglementation espagnole). Renseignez les informations de chaque personne hébergée.",
    occupant: "Occupant {{n}}",
    remove: "Retirer",
    firstName: "Prénom *",
    lastName: "Nom *",
    docId: "CNI / Passeport *",
    birthdate: "Date de naissance",
    nationality: "Nationalité",
    address: "Adresse habituelle",
    addOccupant: "Ajouter un occupant",
    step2: "2 · État de la maison",
    stateIntro: "L'appartement est remis en parfait état avec tout l'inventaire de ménage inclus. Je m'engage à le vérifier à l'arrivée.",
    stateDeadline: "Je dispose de 24 heures à compter de l'entrée",
    stateRest: " pour signaler tout incident. Passé ce délai, toute dégradation ou tout élément manquant constaté pourra être déduit de la caution. En signant, j'accepte ces conditions.",
    signReady: "Signature prête",
    signHint: "Dessinez votre signature avec le doigt ou la souris",
    signClear: "Effacer",
    step3: "3 · Caution ({{amount}} €)",
    depositText1: "{{perWeek}} € par semaine. ",
    depositBold: "Elle est seulement bloquée sur votre carte, pas débitée.",
    depositText2: " Elle est automatiquement libérée après l'état des lieux de sortie si tout est en ordre.",
    depositOk: "Caution bloquée avec succès (rien n'a été débité)",
    depositRedirect: "Redirection…",
    depositBtn: "Bloquer la caution de {{amount}} €",
    submit: "Envoyer les données et la signature",
    submitting: "Envoi…",
    submitted: "Données et signature envoyées ✓",
    help: "Une question : WhatsApp +34 667 39 67 67",
    errMissing: "Renseignez au moins le prénom, le nom et le document de chaque occupant",
    errSignature: "Il manque votre signature de l'état de la maison",
    okSubmitted: "Enregistrement effectué avec succès",
    errSubmit: "L'enregistrement n'a pas pu être envoyé",
    errDeposit: "Le blocage de la caution n'a pas pu être lancé",
  },
  reviews: {
    kicker: "Ce que disent nos hôtes",
    title: "Avis",
    sub: "Expériences réelles dans nos maisons de Cadix.",
  },
};
